var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"mouseup":_vm.getImageHeight}},[_c('figure',{ref:"figure",staticClass:"resizer",class:[_vm.position],style:({ 'max-height': _vm.maxHeight })},[_c('img',{ref:"img",attrs:{"src":_vm.imageUrl,"alt":"Picture","width":"100%","height":"auto"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }